import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  RatesHhgProcure,
  RatesHhgProcureUpdate,
  RatesSroMaster,
  RateTypes,
  StateCountry
} from '../../shared/common-components/common-structure';
import {
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import {HhgRateEditService} from 'src/app/services/hhg-rate-edit/hhg-rate-edit.service';
import {LoadingService} from '../../services/loading/loading.service';
import {AlertService} from '../../services/alert/alert.service';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {
  ConfirmationModalComponent
} from '../../shared/common-components/confirmation-modal/confirmation-modal.component';
import {RatesHhgProcureEdit} from 'src/app/features/hhg-rate-edit/rateshhgprocureedit';
import {UserService} from '../../services/user/user.service';
import {User} from '../../services/user/user';
import {HhgCarrierRateFilingService} from '../hhg-carrier-rate-filing/hhg-carrier-rate-filing.service';
import {
  accessorialsValidator,
  cv1Validator,
  cv2Validator,
  cv3Validator,
  linehaulValidator,
  phoneValidator,
  sitValidator,
  uabValidator
} from './validators';
import {DateFormatPipe} from './my-date-formatter';
import {takeWhile} from 'rxjs/operators';
import {BehaviorSubject, timer} from 'rxjs';
import {CarrierService} from 'src/app/services/carrier/carrier.service';
import AppConstants, {
  CarrierApprovalInfo as CAI,
  stateCodes,
  stateCountry,
  TransportType as TST
} from '../../shared/common-components/AppConstants';
import {Router} from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import {PaginationComponent} from "../../shared/pagination/pagination.component";


@Component({
    selector: 'app-hhg-rate-edit',
    templateUrl: './hhg-rate-edit.component.html',
    styleUrls: ['./hhg-rate-edit.component.css'],
    imports: [
    PaginationComponent,
    ReactiveFormsModule
]
})
export class HhgRateEditComponent implements OnInit, OnDestroy {

  constructor(private fb: UntypedFormBuilder,
              private hhgRateEditService: HhgRateEditService,
              public loader: LoadingService,
              private alertService: AlertService,
              private router: Router,
              private userService: UserService,
              private hhgService: HhgCarrierRateFilingService,
              private modalService: BsModalService,
              private hhgrateService: HhgCarrierRateFilingService,
              private carrierService: CarrierService) {
    this.tmssloader = this.loader;
    this.transportTypeGroup = this.fb.group({
      searchCriteria: new UntypedFormControl(''),
      originName: new UntypedFormControl(''),
      destinationName: new UntypedFormControl('0'),
      rateType: new UntypedFormControl(''),
      statusName: new UntypedFormControl(''),
      rateTableControls: this.fb.array([])
    });
  }


  get getFormData(): UntypedFormArray {
    return <UntypedFormArray>this.transportTypeGroup.get('rateTableControls');
  }

  private tmssloader;
  currentUser: User | any;
  carrierId: any;
  transportTypeFor: string[] = [TST.INTERSTATE, TST.INTRASTATE, TST.INTERNATIONAL];
  intrastateRateArr: number[] = [1, 2, 3, 4, 12, 13, 14, 15, 16];
  interstateRateArr: number[] = [1, 2, 3, 4, 11, 12, 13, 14, 15, 16];
  internationalRateArr: number[] = [5, 6, 7, 8, 17];
  transportRateArr: number[];
  statusList: string[] = [
    'All',
    'Modified',
    'New',
    'Unchanged'
  ];
  isDomestic: boolean;
  isInternational: boolean;
  scac: string;
  origStateList: StateCountry[];
  destStateList: StateCountry[];
  destStateList1: StateCountry[];
  stateCountriesList: StateCountry[];
  rateList: RateTypes[] = [];
  stateCountryVar: string;
  stateCountryDestVar: string;
  ratesHhgProcureList: RatesHhgProcure[];
  ratesHhgProcureEditList: RatesHhgProcureEdit[];
  ratesHhgProcureEditList1: RatesHhgProcureEdit[];
  ratesHhgEditList: RatesHhgProcure[];
  ratesHhgUpdateList: RatesHhgProcure[];
  ratesHhgDeleteArray: number[];
  editErrorMsg: string;
  editButtonText = 'Update';
  updateBtnEnable = false;
  destinationError: boolean;
  destinationErrorMessage = '';
  showIntrastateMessage: Boolean = false;

  pkng = 'Pkng';
  wrhse = 'Wrhse';
  mstor = 'Mstor';
  dlv50miles = 'Dlv50miles';
  dlvHandOut = 'DlvHandOut';

  alaskaDestList: number[] = [341, 342, 343, 344, 345, 346, 347, 348, 349];
  // 2200 THRU 2208 Alaska Destination
  alaskaOrgList: number[] = [256, 261, 264, 271, 272, 273, 305, 309, 319];
  // AN,CV,FB,JN,KD,KN,PB,SA,WG   Alaska Origin
  canadaOrgList: number[] = [255, 257, 279, 287, 294, 296, 297, 302, 306, 307, 312, 323];
  // AB,BC,MB,NB,NL,NS,NT,ON,PE,PQ,SK,YT
  canadaDestList: number[] = [330, 350, 351, 352, 353, 354, 355, 356, 357, 358, 359, 360, 361, 362];
  // 2300 thru 2313

  // Pagination Variables
  itemsPerPage = 10;
  totalItems = 0;
  currentPage = 1;
  totalPages = 0;
  pageReset = false;
  previousPage = 0;
  resultsPage: any = null;
  pageMap: Map<number, any> = new Map<number, any>();
  showingStart: number;
  showingEnd: number;

  modalRef: BsModalRef;

  transportTypeGroup: UntypedFormGroup;
  rateTableControls: UntypedFormArray;
  rateTablePageControls: UntypedFormArray;

  tenderIdError = false;
  linehaulError = false;
  cv1Error = false;
  cv2Error = false;
  cv3Error = false;
  sitError = false;
  accError = false;
  uabError = false;
  phoneError = false;
  emailError = false;
  afterDeleteFlag = false;
  isRateFilingClosed$ =  new BehaviorSubject(false);
  observer$ = new BehaviorSubject(true);
  ratesBidcyclesId;
  sroId: Number = 0;
  sroIdList: RatesSroMaster[] = [];
  sroIdListFiltered: RatesSroMaster[] = [];
  selectedSroId: RatesSroMaster;
  isExtendedStorage;
  carrierApprovalInfo: any;

  static canadaServiceArea(val) {
    return val.stateCountryCode === '2300' || val.stateCountryCode === '2301' || val.stateCountryCode === '2302' || val.stateCountryCode === '2303' || val.stateCountryCode === '2304' ||
      val.stateCountryCode === '2305' || val.stateCountryCode === '2306' || val.stateCountryCode === '2307' || val.stateCountryCode === '2308' || val.stateCountryCode === '2309' ||
      val.stateCountryCode === '2310' || val.stateCountryCode === '2304' || val.stateCountryCode === '2311' || val.stateCountryCode === '2312' || val.stateCountryCode === '2313';
  }

  static dosmmOrgDestCondition(val) {
    return val.stateCountryCode === stateCodes.VA || val.stateCountryCode === stateCodes.MD || val.stateCountryCode === stateCodes.DC;
  }

  ngOnInit() {
    timer(1000, 1000)
      .pipe(takeWhile(() => !this.isRateFilingClosed$.value))
      .subscribe(val => {
        this.userService.isRateFilingClosed()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.isRateFilingClosed$.next(res);
            if (res) {
              this.alertService.warn('Rate Filing Window has been closed!');
              this.router.navigate(['/', 'landing']);
            }
          });
      });
    this.tmssloader.show();
    this.hhgService.getCarrierIdByUser()
      .pipe(takeWhile(() => this.observer$.value))
      .subscribe(carrierId => {
        this.carrierId = carrierId;
        this.getCarrierApprovalInfo();
        this.carrierService.getRateBidCycleId()
          .pipe(takeWhile(() => this.observer$.value))
          .subscribe(res => {
            this.ratesBidcyclesId = res.ratesBidcyclesId;
            this.hhgrateService.getHhgBidCycleAgencies(this.ratesBidcyclesId)
              .pipe(takeWhile(() => this.observer$.value))
              .subscribe(res1 => {
                this.tmssloader.hide();
                this.sroIdList = res1 as RatesSroMaster[];
                this.sortSros();
              }, error => {
                this.tmssloader.hide();
                this.alertService.error('Unable to load Sro Types value. Please try again later or contact system administrator');
              });
          }, error => {
            this.tmssloader.hide();
            this.alertService.error('Unable to load rates bidcycles id  value. Please try again later or contact system administrator');
          });
      }, error => {
        this.tmssloader.hide();
        this.alertService.error('Unable to load TSP info values. Please try again later or contact system administrator');
      });

    this.afterDeleteFlag = false;
    this.intializeFlags();
  }

  getCarrierApprovalInfo() {
    this.hhgService.getCarrierApprovalInfo(this.carrierId).subscribe(res => {
      this.carrierApprovalInfo = res;
      this.getTransportationType();
    }, error => {
      this.alertService.error('TSP Info values are unable to load. Please contact administrator or try again after sometime.');
    });
  }

  getTransportationType() {
    const carrTypes = this.carrierApprovalInfo.filter(x => (x.approvalType === CAI.DOMESTICHHG || x.approvalType === CAI.INTERNATIONALHHG));
    let domesticTrans = [false, false];
    let internationalTrans = false;
    carrTypes.forEach(x => {
      if (x.approvalType === CAI.DOMESTICHHG) {
        if (AppConstants.isNotNullCondition(x.usDotNumber) && (AppConstants.isNotNullCondition(x.ffNumber) || AppConstants.isNotNullCondition(x.mcNumber))) { domesticTrans = [true, true]; }
      }

      if (x.approvalType === CAI.INTERNATIONALHHG) {
        if (AppConstants.isNotNullCondition(x.ffNumber) || AppConstants.isNotNullCondition(x.mcNumber) || AppConstants.isNotNullCondition(x.fmcOtiNumber)) { internationalTrans = true; }
      }
    });
    domesticTrans.push(internationalTrans);
    const removeTrans: string[] = [TST.INTERSTATE, TST.INTRASTATE];
    const removeInter: string[] = [TST.INTERNATIONAL];
    if (domesticTrans[0] === false && domesticTrans[1] === false) { this.transportTypeFor = this.transportTypeFor.filter(x => removeTrans.indexOf(x) === -1); }
    if (domesticTrans[2] === false) { this.transportTypeFor = this.transportTypeFor.filter(x => !removeInter.includes(x)); }
  }

  ngOnDestroy(): void {
  }

  sortSros() {
    this.sroIdListFiltered = [];
    this.transportRateArr = [];
    let arrFlag;
    if (this.transportTypeGroup.controls['searchCriteria'].value == 'International') {
      this.transportRateArr = [...this.internationalRateArr];
    }
    if (this.transportTypeGroup.controls['searchCriteria'].value == 'Interstate') {
      this.transportRateArr = [...this.interstateRateArr];
    }
    if (this.transportTypeGroup.controls['searchCriteria'].value == 'Intrastate') {
      this.transportRateArr = [...this.intrastateRateArr];
    }

    this.sroIdList.forEach(x => {
      x.rateTypesSroEntity.forEach(y => {
        this.transportRateArr.forEach(z => {
          if (y.rateTypeId === z) {
            arrFlag = false;
            this.sroIdListFiltered.forEach(a => {
              if (a.sroId === x.sroId) {
                arrFlag = true;
              }
            });
            if (!arrFlag) {
              this.sroIdListFiltered.push(x);
            }
          }
        });
      });
    });

    this.sroIdListFiltered.sort((a, b) => {
      return (a.sroId > b.sroId) ? 1 : -1;
    });
    const genrlIndex = this.sroIdListFiltered.findIndex(e => {
      return e.sroId === 'GENRL';
    });

    if (genrlIndex !== -1) {
      const genrlElement = this.sroIdListFiltered[genrlIndex];
      this.sroIdListFiltered.splice(genrlIndex, 1);
      this.sroIdListFiltered.splice(0, 0, genrlElement);
    }
  }

  onSearchCriteriaChange(searchCriteriaValue: string) {
    while ((<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).length !== 0) {
      (<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).removeAt(0);
    }
    this.sortSros();
    this.transportTypeGroup.controls['rateType'].setValue('');
    this.transportTypeGroup.controls['originName'].setValue('');
    this.transportTypeGroup.controls['destinationName'].setValue('0');
    this.transportTypeGroup.controls['statusName'].setValue('A');
    this.rateList = [];
    this.ratesHhgDeleteArray = [];
    this.ratesHhgUpdateList = [];
    this.editErrorMsg = '';
    this.editButtonText = 'Update';

    // this.scac = 'AIGP';

    this.pkng = 'Pkng';
    this.wrhse = 'Wrhse';
    this.mstor = 'MStor';
    this.dlv50miles = 'Dlv50miles';
    this.dlvHandOut = 'DlvHandOut';
    this.showIntrastateMessage = false;

    if (searchCriteriaValue === 'Interstate') {
      this.stateCountryVar = 'state';
      this.stateCountryDestVar = 'Service%20Area';
      this.isDomestic = true;
      this.isInternational = false;
    }
    if (searchCriteriaValue === 'Intrastate') {
      this.stateCountryVar = 'state';
      this.stateCountryDestVar = 'state';
      this.isDomestic = true;
      this.isInternational = false;
      this.showIntrastateMessage = true;
    }
    if (searchCriteriaValue === 'International') {
      this.stateCountryVar = 'stateAndCountry';
      this.stateCountryDestVar = 'stateAndCountry';
      this.isDomestic = false;
      this.isInternational = true;
    }

    this.tmssloader.show();
    this.hhgRateEditService.getStateCountry(this.stateCountryVar).subscribe(allState => {
      this.stateCountriesList = allState.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1);
      this.populateOriginList(allState, searchCriteriaValue);
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving State List');
    });
    this.tmssloader.show();
    this.hhgRateEditService.getStateCountry(this.stateCountryDestVar).subscribe(allDestState => {
      this.destStateList = allDestState.filter(country => country.businessType.toLowerCase().indexOf('hhg') > -1);
      if (searchCriteriaValue === 'Interstate') {
        this.destStateList = this.destStateList.filter(x => {
          return (x.stateCountryCode !== '2305' &&
            x.stateCountryCode !== '2302' &&
            x.stateCountryCode !== '0000');
        });
        this.destStateList.forEach(x => {
          if (HhgRateEditComponent.canadaServiceArea(x)) {
            x.stateCountryName = x.stateCountryName + ',CANADA';
          }
        });
      }
      if (searchCriteriaValue === 'International') {
        this.destStateList = this.destStateList.filter(x => {
          return (x.stateCountryCode !== '925E' && x.stateCountryCode !== '210H' &&
            x.stateCountryCode !== '925S' && x.stateCountryCode !== 'CA00' && x.stateCountryCode !== 'AK' &&
            x.stateCountryType !== stateCountry.SERVICEAREA && x.stateCountryCode !== 'US00');
        });
      }
      if (searchCriteriaValue === 'Intrastate') {
        this.destStateList = this.destStateList.filter(x => {
          return ((x.stateCountryType === stateCountry.STATE) &&
            (x.stateCountryCode !== 'AB' && x.stateCountryCode !== 'AK' &&
              x.stateCountryCode !== 'BC' && x.stateCountryCode !== 'LB' &&
              x.stateCountryCode !== 'MB' && x.stateCountryCode !== 'NB' &&
              x.stateCountryCode !== 'NF' && x.stateCountryCode !== 'NL' &&
              x.stateCountryCode !== 'NS' &&
              x.stateCountryCode !== 'NT' && x.stateCountryCode !== 'ON' &&
              x.stateCountryCode !== 'PE' && x.stateCountryCode !== 'PQ' &&
              x.stateCountryCode !== 'SK' && x.stateCountryCode !== 'YT' &&
              x.stateTariffUse !== 1
            ));
        });
      }
      this.destStateList1 = this.destStateList;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving State List');
    });
    this.tmssloader.show();
    const isExtendedStorage = (element) => element.legacyRateType === 11;
    this.hhgRateEditService.getRates('HHG', searchCriteriaValue).subscribe(allRates => {
      if (allRates.findIndex(isExtendedStorage) !== -1) {
        allRates.splice(allRates.findIndex(isExtendedStorage), 1);
      }
      allRates.forEach(element => {
        if (element.businessType === 'HHG') {
          if (searchCriteriaValue === 'Interstate') {
            if ((element.transportationType === 'Domestic') || (element.transportationType === 'Extended Storage')) {
              this.rateList.push(element);
            }
          } else {
            if (searchCriteriaValue === 'Intrastate') {
              if (element.transportationType === 'Domestic') {
                this.rateList.push(element);
              }
            } else {
              if (searchCriteriaValue === 'International') {
                if (element.transportationType === 'International') {
                  this.rateList.push(element);
                }
              }
            }
          }
        }
      });
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving Rate List');
    });
  }

  populateOriginList(allStateCountries, searchCriteriaValue) {
    if (searchCriteriaValue === 'International') {
      this.origStateList = allStateCountries.filter(x => {
        return (x.stateCountryCode !== '925E' &&
          x.stateCountryCode !== '925S' && x.stateCountryCode !== 'CA00' && x.stateCountryCode !== 'AK'
          && x.stateCountryCode !== '210H' && x.stateCountryType !== stateCountry.SERVICEAREA && x.stateCountryCode !== 'US00');
      });
    }
    if (searchCriteriaValue === 'Interstate') {
      if (this.selectedSroId !== undefined && (this.selectedSroId.sroId === 'EXSTG' || this.selectedSroId.sroId === 'CCNTL' || this.selectedSroId.sroId === 'XSARC' || this.selectedSroId.sroId === 'XSTCS')) {
        this.origStateList = allStateCountries.filter(x => {
          return ((x.stateCountryCode !== 'AK') && (x.stateCountryCode !== 'LB') &&
            (x.stateCountryCode !== 'NF') && (x.stateCountryCode !== 'AK') &&
            (x.stateCountryCode !== 'HI') && (x.stateCountryCode !== 'PR') && (x.parentCountryId !== 365));
        });
      } else {
        this.origStateList = allStateCountries.filter(x => {
          return ((x.stateCountryCode !== 'AK') && (x.stateCountryCode !== 'LB') &&
            (x.stateCountryCode !== 'NF') && (x.stateCountryCode !== 'AK') &&
            (x.stateCountryCode !== 'HI') && (x.stateCountryCode !== 'PR'));
        });
      }
    }
    if (searchCriteriaValue === 'Intrastate') {
      this.origStateList = allStateCountries.filter(x => {
        return ((x.stateCountryType === stateCountry.STATE) &&
          (x.stateCountryCode !== 'AB' && x.stateCountryCode !== 'AK' &&
            x.stateCountryCode !== 'BC' && x.stateCountryCode !== 'LB' &&
            x.stateCountryCode !== 'MB' && x.stateCountryCode !== 'NB' &&
            x.stateCountryCode !== 'NF' && x.stateCountryCode !== 'NL' &&
            x.stateCountryCode !== 'NS' && x.stateCountryCode !== 'HI' &&
            x.stateCountryCode !== 'NT' && x.stateCountryCode !== 'ON' &&
            x.stateCountryCode !== 'PE' && x.stateCountryCode !== 'PQ' &&
            x.stateCountryCode !== 'SK' && x.stateCountryCode !== 'YT' &&
            x.stateCountryCode !== 'PR' && x.stateTariffUse !== 1));
      });
    }
  }

  /*
  ** Listens to user selection rate type change
  */
  onRateTypeChange(rateDescription: string) {
    this.pkng = (rateDescription === '11' ? 'Pkng' : 'Category 1 Vehicle');
    this.wrhse = (rateDescription === '11' ? 'Wrhse' : 'Category 2 Vehicle');
    this.mstor = (rateDescription === '11' ? 'MStor' : 'Category 3 Vehicle');
    this.dlv50miles = (rateDescription === '11' ? 'Dlv50miles' : 'SIT');
    this.dlvHandOut = (rateDescription === '11' ? 'DlvHandOut' : 'ACCSRL');

    if ((this.transportTypeGroup.controls['rateType'].value !== '') &&
      (this.transportTypeGroup.controls['originName'].value !== '')) {
      this.tmssloader.show();
      this.search();
    }
  }

  onSroChange(sroMasterId: any) {
    this.selectedSroId = this.sroIdListFiltered.find(sro => sro.sroMasterId === parseInt(sroMasterId));
    this.selectedSroId.rateTypesSroEntity.forEach(x => {
      this.isExtendedStorage = x.rateTypeId === 11 ? true : false;
    });
    if (this.selectedSroId.sroId === 'DOSHW' && this.transportTypeGroup.controls['searchCriteria'].value === 'International') {
      this.origStateList = this.destStateList1.filter(x => {
        return (x.stateCountryCode === stateCodes.MD);
      });
    } else if (this.selectedSroId.sroId === 'DOSSA' && this.transportTypeGroup.controls['searchCriteria'].value === 'International') {
      this.origStateList = this.destStateList1.filter(x => {
        return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC);
      });
      // Note: removed the below logic 08/16 - as per the requirements in story: CATMTMSS-3428
      /*this.destStateList = this.destStateList1.filter(x => {
        return (x.parentCountryId !== 326);
      });*/
      this.populateDossaDestinationList();
    } else if (this.selectedSroId.sroId === 'DOSMM' && this.transportTypeGroup.controls['searchCriteria'].value === 'International') {
      this.populateDosmmOriginList();
      this.populateDosmmDestinationList();
    }  else {
      this.populateOriginList(this.stateCountriesList, this.transportTypeGroup.controls['searchCriteria'].value);
    }
    if ((this.transportTypeGroup.controls['rateType'].value !== '') &&
      (this.transportTypeGroup.controls['originName'].value !== '')) {
      this.tmssloader.show();
      this.search();
    }
  }

  populateDossaDestinationList() {
    this.destStateList = this.destStateList1.filter(x => {
      return (x.stateCountryCode === '5250' || x.stateCountryCode === '108E' ||
        x.stateCountryCode ===  '8650'  || x.stateCountryCode === '1410'  || x.stateCountryCode === '9900'  || x.stateCountryCode === '112A'  ||
        x.stateCountryCode === '5050'  || x.stateCountryCode === '5850'  ||
        x.stateCountryCode === '130N'  || x.stateCountryCode === '2320'  || x.stateCountryCode === '9270'  || x.stateCountryCode === '121K'  ||
        x.stateCountryCode === '2520'  || x.stateCountryCode === '117U'  || x.stateCountryCode === '136T'  || x.stateCountryCode === '109G'  || x.stateCountryCode === '8350'  ||
        x.stateCountryCode === '8210'  || x.stateCountryCode === '5770'  || x.stateCountryCode === '101A' || x.stateCountryCode === '5750' || x.stateCountryCode === '6700' ||
        x.stateCountryCode === '3350'  || x.stateCountryCode === '8180'  || x.stateCountryCode === '6250');
    });
  }

  populateDosmmDestinationList() {
    this.destStateList = this.destStateList1.filter(x => {
      return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC
        || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
        || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
        || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
    });
  }

  populateDosmmDestinationListRemoveDomestic(isVaMdDcVal: string) {
    if (isVaMdDcVal === stateCodes.DC) {
      this.destStateList = this.destStateList1.filter(x => {
        return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA
          || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
          || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
          || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
      });
    }
    if (isVaMdDcVal === stateCodes.MD) {
      this.destStateList = this.destStateList1.filter(x => {
        return (x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC
          || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
          || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
          || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
      });
    }
    if (isVaMdDcVal === stateCodes.VA) {
      this.destStateList = this.destStateList1.filter(x => {
        return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.DC
          || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
          || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
          || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
      });
    }
  }

  populateDosmmOriginList() {
    this.origStateList = this.destStateList1.filter(x => {
      return (x.stateCountryCode === stateCodes.MD || x.stateCountryCode === stateCodes.VA || x.stateCountryCode === stateCodes.DC
        || x.stateCountryCode === '0630' || x.stateCountryCode === '5350' || x.stateCountryCode === '127M'
        || x.stateCountryCode === '131P' || x.stateCountryCode === '7700' || x.stateCountryCode === '7800'
        || x.stateCountryCode === '7600' || x.stateCountryCode === '789S' || x.stateCountryCode === '140T' || x.stateCountryCode === '9500');
    });
  }

  /*
  ** Listens to user selection origin change
  */
  onOriginChange(originName: string) {
    let origin1: StateCountry[];
    origin1 = this.origStateList.filter(x => {
      return x.stateCountryId == +originName;
    });
    this.destStateList = this.destStateList1;
    if (this.transportTypeGroup.controls['searchCriteria'].value === 'International') {
      if (this.selectedSroId.sroId === 'DOSMM') {
        if (origin1[0].stateCountryCode === 'VA' || origin1[0].stateCountryCode === 'MD' || origin1[0].stateCountryCode === 'DC') {
          this.populateDosmmDestinationListRemoveDomestic(origin1[0].stateCountryCode);
        } else {
          this.populateDosmmDestinationList();
        }
      } else if (this.selectedSroId.sroId === 'DOSSA') {
        this.populateDossaDestinationList();
      } else if (origin1[0].stateCountryType === 'State') {
        this.destStateList = this.destStateList.filter(x => {
          return (x.stateCountryType !== 'State' && x.stateCountryCode !== 'CA00' && x.stateCountryCode !== 'AK');
        });
      }
    }
    if ((this.transportTypeGroup.controls['rateType'].value !== '') &&
      (this.transportTypeGroup.controls['originName'].value !== '')) {
      if ((this.transportTypeGroup.controls['searchCriteria'].value == 'Intrastate' && !this.alaskaOrgList.includes(+originName)) || this.isExtendedStorage) {
        this.transportTypeGroup.get('destinationName').setValue(
          this.transportTypeGroup.controls['originName'].value);
        this.transportTypeGroup.controls['destinationName'].disable();
        this.destinationError = false;
        this.destinationErrorMessage = '';
        this.tmssloader.show();
        this.search();
      } else {
        this.transportTypeGroup.controls['destinationName'].enable();
        this.transportTypeGroup.get('destinationName').setValue('');
      }
    }
  }

  /*
  ** Listens to user selection destination change
  */
  onDestinationChange(destinationName: string) {
    console.log(this.transportTypeGroup.value);
    /*if (this.transportTypeGroup.controls['searchCriteria'].value === 'International' &&
      this.selectedSroId.sroId === SRO.DOSMM && HhgRateEditComponent.dosmmOrgDestCondition(destination) &&
      HhgRateEditComponent.dosmmOrgDestCondition(origin)) {
      this.destinationError = true;
      this.destinationErrorMessage = 'DOSMM- Destination cannot be VA,MD or DC';
    }*/
    if (this.alaskaOrgList.includes(+this.transportTypeGroup.controls['originName'].value) &&
      !this.alaskaOrgList.includes(+destinationName) && this.transportTypeGroup.controls['searchCriteria'].value === 'Intrastate') {
      this.destinationError = true;
      this.destinationErrorMessage = `Only Alaskan points are allowed to be chosen for Intrastate`;
    } else {
      this.destinationError = false;
      this.destinationErrorMessage = '';
      if ((this.transportTypeGroup.controls['rateType'].value !== '') &&
        (this.transportTypeGroup.controls['originName'].value !== '')) {
        this.tmssloader.show();
        this.search();
      }
    }
  }

  /*
  ** Listens to user selection status change
  */
  onStatusChange(statusName: string) {
    if ((this.transportTypeGroup.controls['rateType'].value !== '') &&
      (this.transportTypeGroup.controls['originName'].value !== '')) {
      this.tmssloader.show();
      this.search();
    }

  }

  /*
  ** Populates rates hhg procure table
  */
  search() {
    this.ratesHhgDeleteArray = [];
    this.ratesHhgUpdateList = [];
    this.editErrorMsg = '';
    this.intializeFlags();
    if ((this.transportTypeGroup.controls['rateType'].value !== '') &&
      (this.transportTypeGroup.controls['originName'].value !== '')) {
      this.hhgRateEditService.getAllRatesList(this.carrierId, this.ratesBidcyclesId,
        this.transportTypeGroup.controls['rateType'].value,
        this.transportTypeGroup.controls['originName'].value,
        this.isExtendedStorage ? '374' : this.transportTypeGroup.controls['destinationName'].value,
        this.transportTypeGroup.controls['statusName'].value
      ).subscribe(allRatesHhgProcure => {
        this.ratesHhgProcureEditList1 = allRatesHhgProcure;
        this.ratesHhgProcureEditList = [];
        if (this.transportTypeGroup.controls['searchCriteria'].value == 'Interstate') {
          this.ratesHhgProcureEditList1.forEach(x => {
            if ((x.rateTypeId == 1 || x.rateTypeId == 2 || x.rateTypeId == 3 ||
                x.rateTypeId == 4 || x.rateTypeId == 11 || x.rateTypeId == 12 ||
                x.rateTypeId == 13 || x.rateTypeId == 14 || x.rateTypeId == 15) &&
              (x.destinationType == 'Service Area')
            ) {
              this.ratesHhgProcureEditList.push(x);
            }
          });
        }
        if (this.transportTypeGroup.controls['searchCriteria'].value == 'Intrastate') {
          this.ratesHhgProcureEditList1.forEach(x => {
            if (x.rateTypeId == 1 || x.rateTypeId == 2 || x.rateTypeId == 3 ||
              x.rateTypeId == 4 || x.rateTypeId == 12 ||
              x.rateTypeId == 13 || x.rateTypeId == 14 || x.rateTypeId == 15) {
              this.ratesHhgProcureEditList.push(x);
            }
          });
        }
        if (this.transportTypeGroup.controls['searchCriteria'].value == 'International') {
          this.ratesHhgProcureEditList1.forEach(x => {
            if (x.rateTypeId == 5 || x.rateTypeId == 6 || x.rateTypeId == 7 ||
              x.rateTypeId == 8) {
              this.ratesHhgProcureEditList.push(x);
            }
          });
        }
        this.totalItems = this.ratesHhgProcureEditList.length;
        if (this.totalItems > 0) {
          this.setupPagination();
        } else {
          while ((<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).length !== 0) {
            (<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).removeAt(0);
          }
          if (this.afterDeleteFlag === false) {
            this.alertService.info('There are no rate records for this selection criteria!!!');
          } else {
            this.afterDeleteFlag = false;
          }
        }
        this.tmssloader.hide();
      }, error => {
        this.tmssloader.hide();
        this.alertService.error('There was an error retrieving Rates HHg  Procure');
      });
    }
  }

  /*
  ** Listens select delete check & uncheck
  */
  onSelectDelete(isChecked: boolean, procureId: number) {
    if (isChecked) {
      this.ratesHhgDeleteArray.push(procureId);
    } else {
      const index: number = this.ratesHhgDeleteArray.indexOf(procureId);
      if (index !== -1) {
        this.ratesHhgDeleteArray.splice(index, 1);
      }
    }
    if (this.ratesHhgDeleteArray.length > 0) {
      this.editButtonText = 'Delete';
    } else {
      this.editButtonText = 'Update';
    }

  }

  edit() {
    if (this.ratesHhgDeleteArray.length > 0) {
      this.delete();
    }
    if (this.ratesHhgUpdateList.length > 0) {
      this.update();
    }
  }

  /*
  ** Deletes Rates HHG Procure records
  */
  delete() {
    if (this.ratesHhgDeleteArray !== null) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to delete these rate records?';
      this.modalRef.content.title = 'USER DELETE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssloader.show();
          this.hhgRateEditService.deleteRatesHhgProcure(this.ratesHhgDeleteArray).subscribe(response => {
            this.afterDeleteFlag = true;
            this.search();
            this.tmssloader.hide();
            this.alertService.info(response.response);
            this.editButtonText = 'Update';
          });

        }
      });
    }
  }


  /*
  ** Updates Rates HHG Procure records
  */
  update() {
    if (this.ratesHhgUpdateList !== null) {
      this.modalRef = this.modalService.show(ConfirmationModalComponent);
      this.modalRef.content.question = 'Are you sure, you want to update these rate records?';
      this.modalRef.content.title = 'USER UPDATE';
      this.modalRef.content.confirmText = 'Yes';
      this.modalRef.content.cancelText = 'No';
      this.modalRef.content.emitData.subscribe(result => {
        if (result.obj === true) {
          this.tmssloader.show();
          const ratesHhgProcureUpdate : RatesHhgProcureUpdate = {
            ratesHhgProcureEntityList: this.ratesHhgUpdateList,
            carrId: this.carrierId,
            transportType: this.transportTypeGroup.get('searchCriteria').value
          };
          this.hhgRateEditService.updateRatesHhgProcureWithValidateExpirationBonds(ratesHhgProcureUpdate).subscribe(response => {
            this.search();
            this.tmssloader.hide();
            this.alertService.info(response.response);
          },(err:HttpErrorResponse) => {
            console.log(err);
            this.search();
            this.tmssloader.hide();
            this.alertService.error(err.error.response);
          });

        }
      });
    }
  }

  intializeFlags() {
    this.tenderIdError = false;
    this.linehaulError = false;
    this.cv1Error = false;
    this.cv2Error = false;
    this.cv3Error = false;
    this.sitError = false;
    this.accError = false;
    this.uabError = false;
    this.phoneError = false;
    this.emailError = false;
    this.afterDeleteFlag = false;
  }

  /*
  ** Listens to class tender id changes
  */
  onSelectEditTenderId(tenderId: string, procureId: number) {
    this.tenderIdError = false;
    if (tenderId.length < 1 || tenderId.length > 4) {
      this.tenderIdError = true;
    }

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.tenderId = tenderId;
      }
    });
    if (found === 0) {
      this.ratesHhgProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.tenderId = tenderId;
          this.ratesHhgUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Listens to linehaul changes
  */
  onSelectEditLineHaul(lineHaul: number, procureId: number) {
    this.linehaulError = false;
    if (this.transportTypeGroup.controls['searchCriteria'].value !== 'International') {
      if (lineHaul > 100) {
        this.linehaulError = true;
      }
    }
    if (this.transportTypeGroup.controls['searchCriteria'].value === 'International') {
      if (lineHaul <= 0) {
        this.linehaulError = true;
      }
    }
    if (lineHaul.toString().indexOf('.') !== -1) {
      this.linehaulError = true;
    }
    if (lineHaul % 1 !== 0) {
      this.linehaulError = true;
    }
    lineHaul = lineHaul / 1;
    let found = 0;
    const i = 0;


    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === procureId) {
        found = 1;
        e.linehaul = lineHaul;
      }
    });

    if (found === 0) {
      this.ratesHhgProcureEditList.forEach(e => {
        if (e.procureId === procureId) {
          e.linehaul = lineHaul;
          this.ratesHhgUpdateList.push(e);
        }
      });
    }
  }

  /*
  ** Listens to class vehicle 1 changes
  */
  onSelectEditClassVehicle1(classVehicle1: string, procureId: number) {
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });

    this.cv1Error = false;
    if (+classVehicle1 <= 0) {
      if ((rateRecord.rateTypeId === 11) ||
        ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && (rateRecord.rateTypeId !== 11))) {
        this.cv1Error = true;
      }
    }
    if (+classVehicle1.toString().indexOf('.') !== -1) {
      this.cv1Error = true;
    }
    if (+classVehicle1 % 1 !== 0) {
      this.cv1Error = true;
    }
    if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && (+classVehicle1 <= 0)) {
      this.cv1Error = false;
    }
    if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && ((+classVehicle1 > 0  || classVehicle1 === ''))) {
      this.cv1Error = true;
    }

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.classVehicle1 = classVehicle1;
      }
    });

    if (found === 0) {
      rateRecord.classVehicle1 = classVehicle1;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to class vehicle 2 changes
  */
  onSelectEditClassVehicle2(classVehicle2: string, procureId: number) {
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });

    this.cv2Error = false;
    if (+classVehicle2 <= 0) {
      if ((rateRecord.rateTypeId === 11) ||
        ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && (rateRecord.rateTypeId !== 11))) {
        this.cv2Error = true;
      }
    }
    if (+classVehicle2.toString().indexOf('.') !== -1) {
      this.cv2Error = true;
    }
    if (+classVehicle2 % 1 !== 0) {
      this.cv2Error = true;
    }
    if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && (+classVehicle2 <= 0)) {
      this.cv2Error = false;
    }
    if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && ((+classVehicle2 > 0  || classVehicle2 === ''))) {
      this.cv2Error = true;
    }

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.classVehicle2 = classVehicle2;
      }
    });

    if (found === 0) {
      rateRecord.classVehicle2 = classVehicle2;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to class vehicle 3 changes
  */
  onSelectEditClassVehicle3(classVehicle3: string, procureId: number) {
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });

    this.cv3Error = false;
    if (+classVehicle3 <= 0) {
      if ((rateRecord.rateTypeId === 11) ||
        ((this.selectedSroId.sroId !== 'DOSHW' && this.selectedSroId.sroId !== 'FDICC') && (rateRecord.rateTypeId !== 11))) {
        this.cv3Error = true;
      }
    }
    if (+classVehicle3.toString().indexOf('.') !== -1) {
      this.cv3Error = true;
    }
    if (+classVehicle3 % 1 !== 0) {
      this.cv3Error = true;
    }

    if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && (+classVehicle3 === 0)) {
      this.cv3Error = false;
    }
    if ((this.selectedSroId.sroId === 'DOSHW' || this.selectedSroId.sroId === 'FDICC') && (+classVehicle3 > 0 || classVehicle3 === '')) {
      this.cv3Error = true;
    }

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.classVehicle3 = classVehicle3;
      }
    });
    if (found === 0) {
      rateRecord.classVehicle3 = classVehicle3;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to SIT changes
  */
  onSelectEditStorageInTransit(storageInTransit: number, procureId: number) {
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });
    this.sitError = false;
    // allowing -ve values for SIT
    /*    if (+storageInTransit <= 0) {
          this.sitError = true;
        }*/
    if (storageInTransit.toString().indexOf('.') !== -1) {
      this.sitError = true;
    }
    if (storageInTransit % 1 !== 0) {
      this.sitError = true;
    }
    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.storageInTransit = storageInTransit;
      }
    });

    if (found === 0) {
      rateRecord.storageInTransit = storageInTransit;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to Accessorial changes
  */
  onSelectEditAccessorials(accessorials: number, procureId: number) {
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });

    this.accError = false;
    if (accessorials.toString().indexOf('.') !== -1) {
      this.accError = true;
    }
    if (accessorials % 1 !== 0) {
      this.accError = true;
    }
    if (!this.isExtendedStorage) {
      if (this.transportTypeGroup.controls['searchCriteria'].value == 'International') {
        if (accessorials <= 0) {
          this.accError = true;
        }
      } else {
        if (accessorials > 0) {
          this.accError = true;
        }
      }
    } else {
      if (+accessorials <= 0 && this.isExtendedStorage) {
        this.accError = true;
      }
    }

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.accessorials = accessorials;
      }
    });

    if (found === 0) {
      rateRecord.accessorials = accessorials;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to UAB changes
  */
  onSelectEditUnaccompaniedAirBag(unaccompaniedAirBag: any, procureId: number) {
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });
    if (rateRecord.rateTypeId === 11) {
      return;
    }
    this.uabError = false;
    if (unaccompaniedAirBag.toString().indexOf('.') !== -1) {
      this.uabError = true;
    }
    if (unaccompaniedAirBag % 1 !== 0) {
      this.uabError = true;
    }
    if (unaccompaniedAirBag === '') {
      this.uabError = true;
    }
    if (this.canadaOrgList.includes(rateRecord.originId) ||
      this.alaskaOrgList.includes(rateRecord.originId) ||
      this.canadaDestList.includes(rateRecord.destinationId) ||
      this.alaskaDestList.includes(rateRecord.destinationId)) {
      if (unaccompaniedAirBag <= 0) {
        this.uabError = true;
      }
    } else {
      if ((unaccompaniedAirBag > 0) &&
        (this.transportTypeGroup.controls['searchCriteria'].value !== 'International')) {
        this.uabError = true;
      }
    }
    if ((this.selectedSroId.sroId === 'DOSHW') && (unaccompaniedAirBag !== 0)) {
      this.uabError = false;
    }
    if ((this.selectedSroId.sroId === 'DOSHW') && (unaccompaniedAirBag > 0 || unaccompaniedAirBag == '')) {
      this.uabError = true;
    }

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.unaccompaniedAirBag = unaccompaniedAirBag;
        if (unaccompaniedAirBag.toString() === '') {
          e.unaccompaniedAirBag = 0;
        }
      }
    });

    if (found === 0) {
      rateRecord.unaccompaniedAirBag = unaccompaniedAirBag;
      if (unaccompaniedAirBag.toString() === '') {
        rateRecord.unaccompaniedAirBag = 0;
      }
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to phone changes
  */
  onSelectEditBookingPhone(bookingPhone: string, procureId: number) {
    this.phoneError = false;
    if (bookingPhone == null || bookingPhone.length < 1) {
      this.phoneError = true;
    }
    if (!(bookingPhone.match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/))) {
      this.phoneError = true;
    }
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.bookingPhone = bookingPhone;
      }
    });

    if (found === 0) {
      rateRecord.bookingPhone = bookingPhone;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  /*
  ** Listens to email changes
  */
  onSelectEditBookingEmail(bookingEmail: string, procureId: number) {
    this.emailError = false;
    if (bookingEmail == null || bookingEmail.length < 1) {
      this.emailError = true;
    }
    if (bookingEmail.indexOf('@') === -1) {
      this.emailError = true;
    }
    if (bookingEmail.charAt(bookingEmail.length - 1) === '.') {
      this.emailError = true;
    }
    let rateRecord: RatesHhgProcure;
    this.ratesHhgProcureEditList.forEach(e => {
      if (e.procureId === procureId) {
        rateRecord = e;
      }
    });

    let found = 0;
    const i = 0;

    this.ratesHhgUpdateList.forEach(e => {
      if (e.procureId === rateRecord.procureId) {
        found = 1;
        e.bookingEmail = bookingEmail;
      }
    });

    if (found === 0) {
      rateRecord.bookingEmail = bookingEmail;
      this.ratesHhgUpdateList.push(rateRecord);
    }

  }

  getControls() {
    return (<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).controls;
  }

  /*
  ** Binds hhg procure records to the FormArray controls
  */
  setupRateControlsTable(rhprecords: any) {
    const len = (<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).length;
    while ((<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).length !== 0) {
      (<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).removeAt(0);
    }

    for (const rhprecord of rhprecords) {
      const grp = this.fb.group({
        Delete: [''],
        Status: [rhprecord.updateFlag],
        Date: [rhprecord.updateDate],
        Type: [rhprecord.rateTypeId],
        TenderId: [rhprecord.tenderId, [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
        Agency: [rhprecord.sroId],
        Origin: [rhprecord.originName],
        Destination: [rhprecord.destinationName],
        Trans: [rhprecord.linehaul, [Validators.maxLength(5),
          Validators.pattern(/^-?(0|[1-9]\d*)?$/), linehaulValidator(this.transportTypeGroup.get('searchCriteria').value)]],
        Pkng: [rhprecord.classVehicle1, [Validators.maxLength(8),
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          cv1Validator(this.transportTypeGroup.get('searchCriteria').value,
            rhprecord.sroId, rhprecord.rateTypeId, rhprecord.originId, rhprecord.destinationId,
            this.alaskaOrgList, this.alaskaDestList, this.canadaOrgList, this.canadaDestList)]],
        Wrhse: [rhprecord.classVehicle2, [Validators.maxLength(8),
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          cv2Validator(this.transportTypeGroup.get('searchCriteria').value,
            rhprecord.sroId, rhprecord.rateTypeId, rhprecord.originId, rhprecord.destinationId,
            this.alaskaOrgList, this.alaskaDestList, this.canadaOrgList, this.canadaDestList)]],
        Mstor: [rhprecord.classVehicle3, [Validators.maxLength(8),
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          cv3Validator(this.transportTypeGroup.get('searchCriteria').value,
            rhprecord.sroId, rhprecord.rateTypeId, rhprecord.originId, rhprecord.destinationId,
            this.alaskaOrgList, this.alaskaDestList, this.canadaOrgList, this.canadaDestList)]],
        Dlv50miles: [rhprecord.storageInTransit, [Validators.pattern(/^-?(0|[1-9]\d*)?$/), sitValidator(rhprecord.rateTypeId)]],
        DlvHandOut: [rhprecord.accessorials, [Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          accessorialsValidator(this.transportTypeGroup.get('searchCriteria').value,
            rhprecord.rateTypeId)]],
        UAB: [rhprecord.unaccompaniedAirBag, [Validators.pattern(/^-?(0|[1-9]\d*)?$/),
          uabValidator(this.transportTypeGroup.get('searchCriteria').value,
            rhprecord.rateTypeId, rhprecord.originId, rhprecord.destinationId, this.canadaOrgList, this.canadaDestList,
            this.alaskaOrgList, this.alaskaDestList, rhprecord.sroId)]],
        Phone: [rhprecord.bookingPhone, [Validators.required, phoneValidator()]],
        Email: [rhprecord.bookingEmail, [Validators.compose([Validators.required, Validators.email])]],
        ProcureId: [rhprecord.procureId]
      });
      grp.get('Date').setValue(new DateFormatPipe().transform(grp.get('Date').value));
      (<UntypedFormArray>this.transportTypeGroup.get('rateTableControls')).push(grp);
    }
  }

// Set Up Pagination Map
  setupPagination() {
    this.pageMap = new Map<number, any>();
    let pageCount = 1;

    for (let i = 0; i < this.totalItems; i = i + this.itemsPerPage) {
      const pageOfHhgRateEdit = this.ratesHhgProcureEditList.slice(i, i + this.itemsPerPage);
      this.pageMap.set(pageCount, pageOfHhgRateEdit);
      pageCount++;
    }
    this.totalPages = pageCount - 1;
    // Reset the current page to the first page
    this.currentPage = 1;
    this.resultsPage = this.pageMap.get(this.currentPage);
    if (this.currentPage === 1) {
      this.setupRateControlsTable(this.resultsPage);
    }
    this.showingStart = 1;
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
  }

  page(currentPage: number) {
    this.currentPage = currentPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.resultsPage = this.pageMap.get(currentPage);

      if (this.currentPage > 0) {
        this.setupRateControlsTable(this.resultsPage);
      }
    }
    const end = this.currentPage * this.itemsPerPage;
    if (end > this.totalItems) {
      this.showingEnd = this.totalItems;
    } else {
      this.showingEnd = end;
    }
    this.showingStart = (this.currentPage * this.itemsPerPage) - this.itemsPerPage + 1;
  }

  itemsPerPageChanged(itemsPerPage: any) {
    this.itemsPerPage = itemsPerPage;
    if (this.resultsPage != null && this.resultsPage.length !== 0) {
      this.setupPagination();
      this.pageReset = true;
    }
  }
}
